var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blockquote',{staticClass:"QuoteBox",style:({maxWidth: _vm.maxWidth})},[_vm._t("text"),_vm._v(" "),_vm._t("author")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }